"use client";

import { Root } from "@radix-ui/react-separator";
import { type ComponentProps } from "react";

import { cn } from "../../utils";

export type SeparatorProps = ComponentProps<typeof Root>;

const Separator = ({ ref, className, orientation = "horizontal", decorative = true, ...props }: SeparatorProps) => (
  <Root
    ref={ref}
    decorative={decorative}
    orientation={orientation}
    className={cn("shrink-0 bg-neutral-90", orientation === "horizontal" ? "h-px w-full" : "h-full w-px", className)}
    {...props}
  />
);

Separator.displayName = Root.displayName;

export default Separator;
